import {createGlobalStyle} from "styled-components";
// import "./widget-variables.css"

export const GLOBAL_STYLE_CONFIG = {
    prefix: '_isp_v1_root',
    splitByPrefix: (classname: string) => {
        return `${GLOBAL_STYLE_CONFIG.prefix}-${classname}`;
    },
    variable: (component: string, property: string) => {
        return `--${GLOBAL_STYLE_CONFIG.prefix}-${component}-${property}`;
    }
}

export const GlobalStyle = createGlobalStyle`
    /* === Basic var and style for swiper === */
    :root {
        --swiper-navigation-size: var(--_isw_v1_root-swiper-navigation-size, 32px);
        --swiper-theme-color: var(--_isw_v1_root-swiper-theme-color, #212121);
        --swiper-navigation-sides-offset: var(--_isw_v1_root-swiper-navigation-sides-offset, 0);
    }

    .swiper-button-prev,
    .swiper-button-next {
        border-radius: var(--_isw_v1_root-swiper-border-radius, 50%);
        background-color: var(--_isw_v1_root-swiper-bg-color, transparent);
        width: 32px;
        height: 32px;
        padding: 8px;

        &:before, &:after {
            color: var(--_isw_v1_root-swiper-navigation-color, #000);
        }
    ;

        &:hover {
            background-color: var(--_isw_v1_root-swiper-hover-bg-color,
            ${props => props.theme.colors.primary});

            &:after,
            &:before {
                color: var(--_isw_v1_root-swiper-navigation-color, white);
            }
        }
    }

    .swiper-button-prev:after, .swiper-button-next:after {
        font-weight: 500;
        font-size: 18px;
    }

    /* === End Basic var and style for swiper === */
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html {
        scroll-behavior: smooth;
    }

    body.${GLOBAL_STYLE_CONFIG.splitByPrefix("mode-page")} {
        font-size: 16px;
        word-break: break-word;
        font-family: ${props => props.theme.fonts.body};
        background-color: ${({theme}) => theme.colors.background};
        overflow: hidden;
        min-height: 100vh;
    }

   
    img {
        max-width: 100%;
    }


`